<div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="page-header py-5 px-4">
        <button class="back-btn" mat-mini-fab [routerLink]="'/bots'">
            <mat-icon>
                chevron_left
            </mat-icon>
        </button>
        <label>{{botDetails?.name}}</label>
    </div>
    <div>
        <form [formGroup]="editDetailsFormGroup" class="px-4">
            <mat-card style="border: 1px solid #ECECEC;border-radius: 12px;box-shadow: none;">
                <div class="row" style="margin:1% 0% 0% 1%">
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Bot display name</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="displayName"
                                placeholder="Enter display name">
                            <mat-error
                                *ngIf="editDetailsFormGroup.controls.displayName.invalid && editDetailsFormGroup.controls.displayName.errors.required">
                                Display Name is required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Type of bot</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="typeOfBot"
                                placeholder="Enter display name" readonly>
                        </mat-form-field>
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Phone number*</mat-label>
                            </div>
                            <input type="text" class="edit-label" matInput formControlName="phoneNumber"
                                placeholder="Enter display name" readonly>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <mat-form-field class="w-100">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Description*</mat-label>
                            </div>
                            <textarea class="edit-label" matInput #message maxlength="500" cdkTextareaAutosize
                                cdkAutosizeMaxRows="4" placeholder="Type here" formControlName="description"></textarea>
                        </mat-form-field>
                     <div fxLayout="row">
                        <div fxLayout="column">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-label class="mat-input-edit-label">Bot profile photo*</mat-label>
                            </div>
                            <img [src]="botDetails?.photo" width="70" height="70" />
                        </div>
                        <div fxLayout="column">
                            <div fxLayout="row">
                                <button type="button" class="change-btn" fxLayoutAlign="center center"
                                    (click)="selectBotIcon()">
                                    <mat-icon style="margin-right: 10px;">
                                        open_in_new
                                    </mat-icon> Select Template
                                </button>
                            </div>
                            <input #fileInput type="file" hidden (change)="fileUpload($event)" accept="image/*">
                            <button class="change-btn" fxLayoutAlign="center center"
                                (click)="fileInput.click()">
                                <mat-icon style="margin-right: 10px;" class="material-symbols-outlined">
                                    upload
                                </mat-icon> Upload Image
                            </button>
                        </div>
                     </div>
                    </div>
                </div>
            </mat-card>

        </form>
    </div>
    <div>
        <form [formGroup]="addtionalDetailsFormGroup" class="pt-4 px-3">
            <mat-card style="border: 1px solid #ECECEC;border-radius: 12px;box-shadow: none;">
                <div class="row" style="margin:1% 0% 0% 1%">
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <!-- <div>
                            <div>
                                <mat-label class="mat-input-edit-label">Welcome banner</mat-label>
                            </div>
                            <div>
                                <img *ngIf="!welcomeBanner" [src]="botDetails?.welcome_banner" width="200" height="300" />
                                <img *ngIf="welcomeBanner" [src]="welcomeBannerPreview" width="200" height="300" />
                                <p class="library-content">Select from templates library and edit the content</p>
                                <button type="button" mat-button class="verify-btn" (click)="selectTemplate()">Select Template</button>
                                <p class="library-content">Select image for profile photo as JPG or PNG SMALLER THAN 10 MB </p>
                                <button type="button" mat-button class="verify-btn" (click)="uploadTemplate()">Upload Template</button>
                                <input type="file" id="imageFileUpload" accept="image/*" (change)="selectTemplateFile($event)" style="display:none">
                            </div>
                        </div> -->
                        <div>
                            <mat-form-field class="w-100">
                                <div fxLayout="row" fxLayoutGap="10px">
                                    <mat-label class="mat-input-edit-label">Welcome Text</mat-label>
                                </div>
                                <textarea class="edit-label" matInput #message maxlength="100" cdkTextareaAutosize
                                    cdkAutosizeMaxRows="4" placeholder="Type here" formControlName="welcome_text"></textarea>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field class="input-full-width" floatLabel='always'>
                                <div>
                                    <mat-label class="mat-input-custom-label">Customer Support Phone Number</mat-label>
                                    <input type="text" class="placeholder-input" matInput formControlName="customer_support_phone"
                                        placeholder="Typecustomer support phone number" (keypress)="keyPress($event)" maxlength="20" minlength="10">
                                </div>
                                <mat-error *ngIf="addtionalDetailsFormGroup.controls.customer_support_phone.valid ||  addtionalDetailsFormGroup.controls.customer_support_phone.errors.maxlength || addtionalDetailsFormGroup.controls.customer_support_phone.errors.minlength">
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field class="input-full-width" floatLabel='always'>
                            <div>
                                <mat-label class="mat-input-custom-label">Customer Support Email Id*</mat-label>
                                <input type="text" class="placeholder-input" matInput formControlName="customer_support_email"
                                    placeholder="Type customer support email Id">
                            </div>
                            <mat-error *ngIf="!addtionalDetailsFormGroup.controls['customer_support_email'].valid &&
                            addtionalDetailsFormGroup.controls['customer_support_email'].touched">
                                {{ getErrorCustomerEmail() }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="input-full-width" floatLabel='always'>
                            <div>
                                <mat-label class="mat-input-custom-label">Customer Support Url</mat-label>
                                <input type="text" class="placeholder-input" matInput formControlName="support_link"
                                    placeholder="Type customer support url">
                            </div>
                            <mat-error *ngIf="!addtionalDetailsFormGroup.controls['support_link'].valid &&
                            addtionalDetailsFormGroup.controls['support_link'].touched">
                                {{ getErrorForLink() }}
                            </mat-error>
                        </mat-form-field>
                        <div fxLayout="column" fxlayoutGap="1px">
                            <mat-card style="box-shadow: none;">
                                <mat-label class="input-label responsive-custom-font-bot-config">Bot labels*</mat-label>
                                <div class="editor-tag input-full-width py-1" (click)="focusTagInput()">
                                    <span class="tag-item py-1 mr-2" *ngFor="let tag of tags">
                                        <span class="pl-2">{{tag}}</span>
                                        <span class="remove-tag pl-2" (click)="removeTag(tag)">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="10" fill="white" />
                                                <path d="M10.9391 9.99943L13.803 7.14179C13.9284 7.01635 13.9989 6.84623 13.9989 6.66884C13.9989 6.49146 13.9284 6.32133 13.803 6.1959C13.6776 6.07047 13.5075 6 13.3301 6C13.1528 6 12.9827 6.07047 12.8572 6.1959L10 9.06021L7.14276 6.1959C7.01735 6.07047 6.84725 6 6.66988 6C6.49252 6 6.32242 6.07047 6.19701 6.1959C6.07159 6.32133 6.00114 6.49146 6.00114 6.66884C6.00114 6.84623 6.07159 7.01635 6.19701 7.14179L9.06091 9.99943L6.19701 12.8571C6.13458 12.919 6.08504 12.9927 6.05122 13.0738C6.01741 13.155 6 13.2421 6 13.33C6 13.418 6.01741 13.505 6.05122 13.5862C6.08504 13.6674 6.13458 13.741 6.19701 13.803C6.25892 13.8654 6.33259 13.915 6.41375 13.9488C6.49491 13.9826 6.58196 14 6.66988 14C6.75781 14 6.84486 13.9826 6.92602 13.9488C7.00718 13.915 7.08085 13.8654 7.14276 13.803L10 10.9387L12.8572 13.803C12.9192 13.8654 12.9928 13.915 13.074 13.9488C13.1551 13.9826 13.2422 14 13.3301 14C13.418 14 13.5051 13.9826 13.5863 13.9488C13.6674 13.915 13.7411 13.8654 13.803 13.803C13.8654 13.741 13.915 13.6674 13.9488 13.5862C13.9826 13.505 14 13.418 14 13.33C14 13.2421 13.9826 13.155 13.9488 13.0738C13.915 12.9927 13.8654 12.919 13.803 12.8571L10.9391 9.99943Z"
                                                    fill="#386AF6" stroke="#386AF6" stroke-width="0.5" />
                                            </svg>
                                        </span>
                                    </span>
                                    <input #tagInput type="text" class="input-tag px-0" (keyup)="onKeyUp($event)" [ngStyle]="tags.length == 0 && {'width':'50%'}" [placeholder]="tags.length == 0?'Type here to add labels/tags...':''">
                                </div>
                                <p class="text-danger" *ngIf="tags_error!=''">{{tags_error}}</p>
                            </mat-card>
                          </div>


                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 px-4">
                        <div>
                            <mat-label Style="font-weight: 500;font-size: 12px;color: #0E0E0E;">
                                Add Configuration Parameters
                            </mat-label>
                            <div class="camera-btn" style="padding: 1.3% 2% 0% 2%;">
                                <mat-icon style="font-size:21px; height: auto;">
                                    <span class="material-symbols-outlined" style="color: #999999;">
                                        photo_camera
                                    </span>
                                </mat-icon>
                                <span class="camera-label px-3" style="vertical-align: super;">Camera</span>
                                <span>
                                    <label class="switch">
                                        <input type="checkbox" formControlName="allow_user_media">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                            </div>

                        </div>
                        <div>
                            <mat-form-field class="input-full-width" floatLabel='always'>
                                <div>
                                    <mat-label class="mat-input-custom-label">Webhook URL</mat-label>
                                    <input type="text" class="placeholder-input" matInput formControlName="webhook_url"
                                        placeholder="Type Webhook URL">
                                </div>
                                <mat-error *ngIf="addtionalDetailsFormGroup.controls.webhook_url.invalid && addtionalDetailsFormGroup.controls.webhook_url.errors.pattern">
                                    Please Enter Valid Url
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field class="input-full-width" floatLabel='always'>
                                <div>
                                    <mat-label class="mat-input-custom-label">Persistent Menu</mat-label>
                                    <mat-select formControlName="persistentMenu" placeholder="No Button"
                                        (selectionChange)="onPersistentMenuSelection($event.value)">
                                        <mat-option value="null" class="placeholder-input">None</mat-option>
                                        <mat-option style="border:1px solid #ECECEC" value="1">
                                            Add 1 Button
                                        </mat-option>
                                        <mat-option style="border:1px solid #ECECEC" value="2">
                                            Add 2 Button
                                        </mat-option>
                                        <mat-option style="border:1px solid #ECECEC" value="3">
                                            Add 3 Button
                                        </mat-option>
                                        <mat-option style="border:1px solid #ECECEC" value="4">
                                            Add 4 Button
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </mat-form-field>
                        </div>                                   
                        <div formArrayName="buttons">
                            <div *ngFor="let element of addtionalDetailsFormGroup.get('buttons')['controls'];let i=index;">
                                <div class="py-2" [formGroupName]="i">
                                    <div style="background:#F9FBFF;border-radius: 8px; padding: 10px;margin-bottom:2%;">
                                        <label class="dynamic-btn-heading">Button - {{i+1}}</label>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6">
                                            <div>
                                                <label class="mat-input-custom-label">Button Text</label>
                                            </div>
                                            <mat-form-field floatLabel='never' class="w-100">
                                                <input type="text" class="placeholder-input" matInput
                                                    placeholder="Enter Button Text" formControlName="body">
                                            </mat-form-field>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6">
                                            <div>
                                                <label class="mat-input-custom-label">Reply </label>
                                            </div>
                                            <mat-form-field floatLabel='never' class="w-100">
                                                <input type="text" class="placeholder-input" matInput
                                                    placeholder="Enter Reply" formControlName="reply">
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <label class="mat-input-custom-label">Select icon</label>
                                            <div  *ngIf="!iconSelected[i]">
                                                <button type="button" class="verify-btn" (click)="openIconPopup(i)">Select from Library</button>
                                            </div>
                                            <div fxLayout="row" *ngIf="iconSelected[i]">
                                                <div fxLayout="row">
                                                    <div fxLayout="column" class="px-2 icon-library-img" fxLayoutAlign="center center">
                                                        <div class="tempalte-img" style="text-align: center;
                                                        background: #EBF1FF;
                                                        border-radius: 25px;
                                                        min-width: 44px;
                                                        height: 44px;">
                                                            <img [src]="'assets/'+element.controls.icon.value+'.svg'" style="width: 50%;padding-top: 25%;"/>
                                                        </div>
                                                    </div>
            
                                                </div>
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
            
                                                        <button type="button" class="change-btn" fxLayoutAlign="center center"
                                                            (click)="openIconPopup(i)">
                                                            <mat-icon style="margin-right: 10px;">
                                                                cached
                                                            </mat-icon> Change Icon
                                                        </button>
                                                    </div>
                                                    <button class="change-btn" fxLayoutAlign="center center"
                                                        (click)="deleteIcon(i)">
                                                        <mat-icon style="margin-right: 10px;" class="material-symbols-outlined">
                                                            delete
                                                        </mat-icon> Delete Icon
                                                    </button>
                                                </div>
                                            </div>


                                            <!-- <div>
                                                <div *ngIf="iconSelected[i] && addtionalDetailsFormGroup.get('buttons')['controls'][i].value.icon == 'edit-registration'">
                                                    <div class="icon-library-img">
                                                        <div class="tempalte-img">
                                                            <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                                            </svg>
                                                        </div>
                                                        <div class="template-icon-img">
                                                            <img src="assets/chg-md-img.svg" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="iconSelected[i] && addtionalDetailsFormGroup.get('buttons')['controls'][i].value.icon == 'registration'">
                                                    <div class="icon-library-img">
                                                        <div class="tempalte-img">
                                                            <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                                            </svg>
                                                        </div>
                                                        <div class="template-icon-img">
                                                            <img src="assets/profile-img.svg" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div 
                                                    *ngIf="iconSelected[i] && addtionalDetailsFormGroup.get('buttons')['controls'][i].value.icon == 'home'">
                                                    <div class="icon-library-img">
                                                        <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                                            </svg>
                                                        </div>
                                                        <div class="template-icon-img">
                                                            <img src="assets/home.svg" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div 
                                                    *ngIf="iconSelected[i] && addtionalDetailsFormGroup.get('buttons')['controls'][i].value.icon == 'edit-age'">
                                                    <div class="icon-library-img">
                                                        <div class="tempalte-img"><svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="26.051" cy="26.051" r="26.051" fill="#E1E9FE" />
                                                            </svg>
                                                        </div>
                                                        <div class="template-icon-img">
                                                            <img src="assets/edit-age.svg" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div *ngIf="iconSelected[i]">
                                                    <div>
                                                        <button type="button" class="change-btn" (click)="openIconPopup(i)">
                                                            <mat-icon>cached</mat-icon> Change Icon
                                                        </button>
                                                    </div>
                                                    <button class="change-btn" (click)="deleteIcon(i)">
                                                        <mat-icon class="material-symbols-outlined">
                                                            delete
                                                        </mat-icon> Delete Icon
                                                    </button>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div style="display: flex; align-items: center; flex-direction: column;">
                                <div style="display: flex; align-items: center; justify-content: space-between; width: 86px; height: 32px; border-radius: 99px; border: 1px solid #ECECEC; padding: 8px;">
                                    <label class="switch">
                                        <input type="checkbox" [(ngModel)]="isChecked">
                                        <span class="slider round" [ngStyle]="{'background-color': isChecked ? '#386AF6' : 'gray'}" (click)="onSlide()"></span>
                                    </label>                                                                 
                                    <label style="font: Montserrat; font-weight: 700; font-size: 10px;">Faqs</label>
                                </div>
                            </div>
                        
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div style="display: flex; gap: 4px; cursor: pointer; margin-top: 20px;">
                                    <div style="display: flex;">
                                        <img style="width: 16px; height: 16px;" src="assets/download-icon-blue.svg"/>
                                        <p style="font-weight: 500; font-size: 10px; color: #386AF6;" (click)="downloadTemplate()">Download Template</p>
                                    </div>
                                </div>
                        
                                <div style="display: flex; gap: 10px; position: relative; align-items: center;">
                                    <button
                                        style="width: 87px; height: 24px; color: #386AF6; background-color: white; border: 1px solid#386AF6; border-radius: 50px; cursor: pointer; font-size: 8px; display: flex; justify-content: center; align-items: center;"
                                        (click)="xlsxfileInput.click()">
                                        <img style="width: 16px; height: 16px;" src="assets/upload-icon.svg"/>
                                        Upload FAQs
                                    </button>
                                    <input
                                        #xlsxfileInput
                                        type="file"
                                        accept=".xlsx, .xls"
                                        (change)="onFileSelected($event)"
                                        style="display: none;"
                                        [attr.disabled]="isDisabled ? true : null"/>
                                </div>
                            </div>
                        </div>
                        <div  style="display: flex; justify-content: space-between;">
                            <p *ngIf="faq_supported" style="font-size: 10px; font-weight: 500;">Status: FAQs uploaded</p>
                            <p style="font-size: 10px; font-weight: 500; text-align: right; color: #999999;">(only files uploaded in the provided template will be considered)</p>
                        </div>
                        <div *ngIf="selectedFile" style="display: flex; gap: 10px;">
                            <div>
                                <p style="margin-right: 5px; margin-bottom: 0; display: inline-block; position: relative; white-space: nowrap;">
                                    <span #filename>{{ selectedFile.name }}</span>
                                </p>
                                <div style="height: 1px; background-color: #386AF6; width: calc({{ filename.offsetWidth }}px)"></div>
                            </div>
                            <img src="assets/delete-icon-red.svg" style="width: 32px; height: 24px; cursor: pointer;" (click)="onFileRemove()"/>
                        </div> 
                        <div *ngIf="errorMessage" style="margin-top: 10px; font-size: 10px; color: red;">
                            <p>Status: Upload Failed.{{ errorMessage }}</p>
                        </div>                                           
                        <hr style="border: 0; border-top: 1px solid #999999; flex-grow: 1;"> 
                    </div>
                </div>
                <div class="text-center pt-5">
                    <button type="button" class="verify-btn px-5 py-2 res-w-100"  style="background: #386AF6; color:#fff;font-family: 'Montserrat';
                  font-style: normal;font-size: 14px; " (click)="saveBotDetails()">Submit Changes
                        <mat-icon style="vertical-align: middle;">
                            chevron_right
                        </mat-icon>
                    </button>
                </div>
            </mat-card>
        </form>
    </div>
</div>